module.exports = __webpack_public_path__ + "static/media/address.e3484b2c.png";